import hubspot from "../assets/hubspot-icon.png";
import salesforce from "../assets/crm/salesforce.png";
import dealcloud from "../assets/crm/dealcloud-mark.png";
import { errorDetail } from "./errorDetail";

// Presentation only: the backend catalog owns availability and permissions.
export const CRM_PRESENTATION = {
  hubspot: { label: "HubSpot", logo: hubspot },
  salesforce: { label: "Salesforce", logo: salesforce },
  dealcloud: { label: "DealCloud", logo: dealcloud },
};

export const crmRequestError = (error, fallback = "HubSpot is unavailable. Please try again.") => (
  errorDetail(error?.response?.data?.detail, fallback)
);

// Machine code for recovery decisions only; never return a structured detail to UI.
export const crmRequestErrorCode = (error) => {
  const code = error?.response?.data?.detail?.code;
  return typeof code === "string" ? code : "";
};
